import { defineComponent } from 'vue'

const Section = defineComponent({
  setup(props, ctx) {
    return () => {
      return <section>{ctx.slots.default ? ctx.slots.default() : ''}</section>
    }
  }
})

export default Section
